import './OfflineBoundary.css';
import {useEffect, useLayoutEffect, useState, type PropsWithChildren} from 'react';
import {useTranslation} from 'react-i18next';

// Keep the mounted workflow and retry keys; mask it while the browser is offline.
export default function OfflineBoundary({children}: PropsWithChildren) {
  const {t} = useTranslation();
  const [offline, setOffline] = useState(navigator.onLine === false);
  useLayoutEffect(() => {
    document.documentElement.dataset.mesombOffline = String(offline);
    return () => {delete document.documentElement.dataset.mesombOffline;};
  },[offline]);
  useEffect(() => {
    const update = () => setOffline(navigator.onLine === false);
    window.addEventListener('offline',update);window.addEventListener('online',update);window.addEventListener('pageshow',update);
    document.addEventListener('visibilitychange',update);
    return () => {window.removeEventListener('offline',update);window.removeEventListener('online',update);window.removeEventListener('pageshow',update);document.removeEventListener('visibilitychange',update);};
  },[]);
  return <>
    <div hidden={offline} style={offline ? {display:'none'} : undefined}>{children}</div>
    {offline && <div className='p-8' role='alert'>
      <h1>{t('Connection unavailable')}</h1>
      <p>{t('Reconnect to view your data. If a payment was in progress, check its status before retrying.')}</p>
    </div>}
  </>;
}
